export const languageList = [
  { code: 'ar', display: 'Arabic' },
  { code: 'bn', display: 'Bengali' },
  { code: 'cs', display: 'Czech' },
  { code: 'da', display: 'Danish' },
  { code: 'de', display: 'German' },
  // { code: "de-AT", display: "German (Austria)" },
  // { code: "de-CH", display: "German (Switzerland)" },
  // { code: "de-DE", display: "German (Germany)" },
  { code: 'el', display: 'Greek' },
  { code: 'en', display: 'English' },
  // { code: "en-AU", display: "English (Australia)" },
  // { code: "en-CA", display: "English (Canada)" },
  // { code: "en-GB", display: "English (Great Britain)" },
  // { code: "en-IN", display: "English (India)" },
  // { code: "en-NZ", display: "English (New Zeland)" },
  // { code: "en-SG", display: "English (Singapore)" },
  // { code: "en-US", display: "English (United States)" },
  { code: 'es', display: 'Spanish' },
  // {code: "es-AR, display:	"Spanish (Argentina)"},
  // {code: "es-ES", display:	"Spanish (Spain)"},
  // {code: "es-UY, display:	"Spanish (Uruguay)"}
  // {code: "fi	Finnish
  { code: 'fr', display: 'French' },
  // {code: "fr-BE	French (Belgium)
  // {code: "fr-CH	French (Switzerland)
  // {code: "fr-FR	French (France)
  // {code: "fy	Frysian
  // {code: "fy-NL	Frysian (Netherlands)
  { code: 'hi', display: 'Hindi' },
  // {code: "hr	Croatian
  // {code: "it	Italian
  // {code: "it-CH	Italian (Switzerland)
  // {code: "it-IT	Italian (Italy)
  // {code: "ja	Japanese
  // {code: "ko	Korean
  // {code: "nl	Dutch
  // {code: "nl-BE	Dutch (Belgium)
  // {code: "nl-NL	Dutch (Netherlands)
  // {code: "no	Norwegian
  // {code: "no-NO	Norwegian (Norway)
  // {code: "pa	Punjabi
  // {code: "pl	Polish
  // {code: "pt	Portuguese
  // {code: "pt-BR	Portuguese (Brazil)
  // {code: "ru	Russian
  // {code: "ru-RU	Russian (Russia)
  // {code: "sr	Serbian
  // {code: "sr-RS	Serbian (Serbia)
  // {code: "sv	Swedish
  // {code: "sv-SE	Swedish (Sweden)
  // {code: "te	Telegu
  // {code: "zh	Chinese
  // {code: "zh-CN	Chinese (China)
  // {code: "zh-HK	Chinese (Hong Kong)
  // {code: "zh-SG	Chinese (Singapore)
  // {code: "zh-TW	Chinese (Taiwan)
];
